import { render } from "./CourseRegistryEdit.vue?vue&type=template&id=2c5d7754"
import script from "./CourseRegistryEdit.vue?vue&type=script&lang=js"
export * from "./CourseRegistryEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__